// extracted by mini-css-extract-plugin
export default {"item":"MenuItem_item__FEM6w","info":"MenuItem_info__wySeS","addToCart":"MenuItem_addToCart__UVfw0","action":"MenuItem_action__L5FVu","quantity":"MenuItem_quantity__OaRCR"};